import { type FunctionComponent } from 'react';

import { useSharedStateSelector } from '@trello/shared-state';

import type { FeatureNames } from './featuresInfo';
import { FeedbackCollector } from './FeedbackCollector';
import { feedbackCollectorSharedState } from './feedbackCollectorSharedState';

export const FeedbackCollectorManager: FunctionComponent = () => {
  const { isOpen, featureName, flagTreatment, onFeedbackGiven, attributes } =
    useSharedStateSelector(feedbackCollectorSharedState, (state) => ({
      isOpen: state.isOpen,
      featureName: state.featureName,
      flagTreatment: state.flagTreatment,
      onFeedbackGiven: state.onFeedbackGiven,
      attributes: state.attributes,
    }));

  if (!isOpen) {
    return null;
  }

  return (
    <FeedbackCollector
      featureName={featureName as FeatureNames}
      flagTreatment={flagTreatment}
      onFeedbackGiven={onFeedbackGiven}
      attributes={attributes}
    />
  );
};
